import React, { useContext, useEffect } from 'react';
import '../styles/ContentStyle.css';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import { Context as MainContext } from '../context/MainContext';
import { Typography } from '@material-ui/core';

const Reservation = () => {
  const {
    state,
    clientConfirmation,
    createDateOptions,
    createHalfHourIntervals,
    setReservationDate,
    setReservationTime,
  } = useContext(MainContext);
  useEffect(() => {
    createDateOptions(
      state.awb.inventoryExpirationDate,
      state.stationHours,
      state.station
    );
  }, []);
  useEffect(() => {
    if (state.reservationDate) {
      if (!state.reservationDate.includes('Fecha')) {
        createHalfHourIntervals(state.reservationDate, state.stationHours);
      }
    }
  }, [state.reservationDate]);

  const dropDownDates = () => {
    return (
      <Dropdown.Menu className="DropdownMenu">
        {state.availableDates.map((item) => (
          <Dropdown.Item
            className="DropdownItem"
            key={item ? item : null}
            onClick={onDateSelected(item)}
          >
            {item}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    );
  };
  const dropDownTimes = () => {
    return (
      <Dropdown.Menu className="DropdownMenu">
        {state.availableTimes.map((item) => (
          <Dropdown.Item
            className="DropdownItem"
            key={item ? item : null}
            onClick={onTimeSelected(item)}
          >
            {formatTime(item)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    );
  };
  const formatTime = (item) => {
    if (item.includes(':')) {
      var timeArray = item.split(':');
      return timeArray[0] + ':' + timeArray[1];
    }
    return item;
  };
  const renderDateDropDown = () => {
    return state.availableDates.length === 0 ? null : (
      <Dropdown className="Dropdown">
        <Dropdown.Toggle
          className="DropdownButton"
          style={{
            color: state.reservationDate === 'Fecha!' ? 'red' : '#333',
            fontWeight: state.reservationDate === 'Fecha!' ? 'bold' : 'normal',
          }}
          size="lg"
          id="dropdown-basic"
        >
          {state.reservationDate}
        </Dropdown.Toggle>
        {dropDownDates()}
      </Dropdown>
    );
  };
  const renderTimeDropDown = () => {
    return state.reservationDate.includes('Fecha') ||
      state.reservationDate.includes('Horario') ? null : (
      <Dropdown className="Dropdown">
        <Dropdown.Toggle
          className="DropdownButton"
          style={{
            color: state.reservationTime === 'Horario!' ? 'red' : '#333',
            fontWeight:
              state.reservationTime === 'Horario!' ? 'bold' : 'normal',
          }}
          size="lg"
          id="dropdown-basic"
        >
          {formatTime(state.reservationTime)}
        </Dropdown.Toggle>
        {dropDownTimes()}
      </Dropdown>
    );
  };
  const renderConfirmationButton = () => {
    return !state.reservationDate.includes('Fecha') ? (
      !state.reservationTime.includes('Horario') ? (
        <Button className="Button" onClick={() => onConfirmed()} size="lg">
          {state.awbState === 'NI' ? 'CONFIRMAR VISITA' : 'REPROGRAMAR'}
        </Button>
      ) : null
    ) : null;
  };
  const onDateSelected = (value) => () => {
    setReservationDate(value);
    setReservationTime('Horario');
  };
  const onTimeSelected = (value) => () => {
    setReservationTime(value);
  };
  const onConfirmed = () => {
    if (state.reservationDate.includes('Fecha')) {
      setReservationTime('Fecha!');
      return;
    }
    if (state.reservationTime.includes('Horario')) {
      setReservationTime('Horario!');
      return;
    }
    var timeArray = state.reservationTime.split(':');
    var dateArray = state.reservationDate.split('/');
    var confirmDate =
      dateArray[0] + dateArray[1] + dateArray[2] + timeArray[0] + timeArray[1];
    var betterStr = confirmDate.replace(/[^ -~]/g, '');
    clientConfirmation(state.awb.id, betterStr);
  };
  return (
    <div className="ContentContainer">
      <div className="TitleContainer">
        <Typography variant="h6" noWrap>
          Hola {state.awb.consigneeName}
        </Typography>
      </div>
      <div className="MainContentContainer">
        <Typography variant="subtitle1" className="SubtitleText">
          Selecciona la fecha y hora en la que estarás recolectando tu envío
        </Typography>
        <Typography variant="h6" className="AWBText">
          ******{state.awb.awbNumber.substring(6)}
        </Typography>
        {renderDateDropDown()}
        {renderTimeDropDown()}
        {renderConfirmationButton()}
      </div>
      <div className="AddressContainer">
        <Typography variant="body1">
          {state.station.name}: {state.station.address1}&nbsp;&nbsp;
        </Typography>
        {state.station.google_maps_id ? (
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`https://www.google.com/maps/search/?api=1&query=DHL&query_place_id=${state.station.google_maps_id}`}
          >
            <Typography variant="body1" noWrap>
              Google Maps
            </Typography>
          </a>
        ) : null}
      </div>
      <div className="ThankYouNoteContainer">
        <Typography variant="h5" noWrap>
          ¡Gracias por elegir DHL!
        </Typography>
      </div>
    </div>
  );
};
export default Reservation;
